<style>.zoezi-google-map>div{
	min-height:100px;
    background:#eee;
    position:relative;
}
.zoezi-google-map>div>iframe{
	width:100%; height:100%;
}
.zoezi-google-map>div:after{
	content:'';
    display:block;
    position:absolute;
    left:0; top:0;
    width:100%; height:100%;
    background-color:currentColor;
    mix-blend-mode:screen;
    pointer-events:none;
}
.zoezi-google-map .zoezi-google-map-instruction{
    font-size: 14px;
    background:white;
    height:210px;
    left: 50%;
    margin-left: -150px;
    line-height: 24px;
    width:300px;
    position:absolute;
    top: 50%;
    margin-top: -105px;
    padding: 20px;
    white-space:pre-line;
    box-shadow:0 1px 3px rgba(0,0,0,.2), 0 3px 9px rgba(0,0,0,.1), 0 9px 27px rgba(0,0,0,.05);
    border-radius: 5px;
}</style>
<template><div class="zoezi-google-map">
    <div v-html="embed" :style="{ height: height, color: color }"></div>
    <div v-if="$root && $root.edit" class="zoezi-google-map-instruction">
        <strong>Att skapa en inbäddningskod</strong>
        1. Öppna <a href="https://google.se/maps" target="_blank">Google Maps här &raquo;</a>
        2. Sök upp önskad plats
        3. I vänsterpanelen, klicka på <em>Dela</em> <v-icon small>mdi-share-variant-outline</v-icon>
        4. Klicka på fliken <em>Bädda in en karta</em>
        5. Klicka på <em>Kopiera HTML</em>
        6. Klistra in koden i fältet <em>Inbäddningskod</em>.
    </div>
</div></template>
<script>export default {
    props: {
        embed: {
            title: 'Inbäddningskod',
            type: String,
            default: ''
        },
        height: {
            title: 'Höjd',
            type: String,
            fulltype: 'csssize'
        },
        color: {
            title: 'Överläggsfärg',
            type: String,
            fulltype: 'color'
        },
    },
    data: () => ({
    }),
    methods: {

    }
}</script>